module.exports = __webpack_public_path__ + "a382b6e04c8234df1f7063631bade0fd.png";